type PropTypes = {
  className?: string
}

const RotateCameraIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      className={className}
    >
      <path
        fill="currentColor"
        d="m8.77 19.365-1.055-1.053 1.943-1.974c-2.037-.27-3.74-.804-5.107-1.6C3.184 13.94 2.5 13.027 2.5 12c0-1.23.918-2.287 2.753-3.172C7.088 7.943 9.337 7.5 12 7.5c2.663 0 4.912.443 6.747 1.328S21.5 10.77 21.5 12c0 .88-.505 1.686-1.514 2.42-1.009.732-2.337 1.286-3.986 1.66v-1.53c1.283-.333 2.27-.746 2.962-1.238C19.654 12.822 20 12.383 20 12c0-.553-.712-1.19-2.137-1.914S14.483 9 12 9c-2.483 0-4.437.362-5.862 1.086C4.713 10.809 4 11.447 4 12c0 .438.49.945 1.467 1.52.979.574 2.283.993 3.914 1.257l-1.666-1.665 1.054-1.054 3.654 3.653-3.654 3.654Z"
      />
    </svg>
  )
}

export default RotateCameraIcon
